(function() {

	$('#genModal').on('show.bs.modal', function (event) {
		var button	= $(event.relatedTarget);
		var title		= button.data('title');
		var content	= button.data('body');
		var modal		= $(this);

		modal.find('.modal-title').text(title);
		modal.find('.modal-body').text(content);
	}).on('hide.bs.modal', function (event) {
		var modal		= $(this);
		modal.find('.modal-title').html('');
		modal.find('.modal-body').html('');
		modal.find('.modal-footer').html('');
	});


})();